import {createFeatureSelector, createSelector} from '@ngrx/store';
import {Features} from '../features';
import {Dictionary} from '@ngrx/entity';
import {ParametryZbioruUszkodzenPrzedmiotow, ZbiorUszkodzenPrzedmiotow} from './zbiorUszkodzenPrzedmiotow';
import {adapterZbiorUszkodzenPrzedmiotow, ZbiorUszkodzenPrzedmiotowState} from './zbiorUszkodzenPrzedmiotow.reducers';

const {
  selectEntities,
  selectAll
} = adapterZbiorUszkodzenPrzedmiotow.getSelectors();

export const selectZbiorUszkodzenPrzedmiotow = createFeatureSelector<ZbiorUszkodzenPrzedmiotowState>(Features.ZBIOR_USZKODZEN_PRZEDMIOTOW);

export const selectAllZbiorUszkodzenPrzedmiotow = createSelector(
  selectZbiorUszkodzenPrzedmiotow,
  selectAll
);

export const selectEntitiesZbiorUszkodzenPrzedmiotow = createSelector(
  selectZbiorUszkodzenPrzedmiotow,
  selectEntities
);

export const selectZbiorUszkodzenPrzedmiotowById = createSelector(
  selectEntitiesZbiorUszkodzenPrzedmiotow,
  (entities: Dictionary<ZbiorUszkodzenPrzedmiotow<ParametryZbioruUszkodzenPrzedmiotow>>, id: number) => entities[id]
);

export const selectIdPrzedmiotowWZbiorze = createSelector(
  selectZbiorUszkodzenPrzedmiotow,
  (zbiorPrzedmiotow) => zbiorPrzedmiotow.ids.map(id => +id)
);

export const czyWiecejNizJedenPrzedmiotKalkulowalny = (idsPrzedmiotowNiekalkulowalnych: number[]) => createSelector(
  selectZbiorUszkodzenPrzedmiotow,
  (zbiorPrzedmiotow) => {
    const ids = zbiorPrzedmiotow.ids.map(id => +id);
    const kalkulowalneIds = ids.filter((id) => !idsPrzedmiotowNiekalkulowalnych.includes(id));
    return kalkulowalneIds.length > 1;
  }
);
